import React from 'react'

import LevelTitle from './level-title'

const NextLevel = (props) => {
  return (
    <div
      className={`level-${props.level_number}`}
    >
      <React.Fragment>
        <LevelTitle
          authenticated={props.authenticated}
          active_url={props.active_url}
          path_list={props.path_list}
          level={props.level}
          level_number={props.level_number + 1}
        />
        {props.level.next_level &&
          props.level.next_level.map((level, index) => {
            if (
              typeof window !== `undefined`
              && window.location.href.includes(props.level.section_url)
            ) {
              return (
                <NextLevel
                  authenticated={props.authenticated}
                  active_url={props.active_url}
                  key={`${level.title}-${index}`}
                  level={level}
                  level_number={props.level_number + 1}
                />
              )
            } else {
              return (<React.Fragment key={`${level.title}-${index}`} />)
            }
        })}
      </React.Fragment>
    </div>
  )
}

export default NextLevel